import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { timer, BehaviorSubject, Subscription, catchError, switchMap, tap, repeat } from 'rxjs';
import { AgentStatus } from '@imunify360-api/misc';
import { AppState } from 'app/core/app.service';
import { InstallationBackendService } from './installation-backend.service';
import { LogChunk } from 'app/utils/log-box/log-box.component';


export const LOG_REFRESH_INTERVAL = 3000;
export const STATUS_REFRESH_INTERVAL = 5000;
export const LOG_CHUNK_SIZE = 1024 * 1024;

@Injectable()
export class InstallationService {
    accumulatedLog = new BehaviorSubject<LogChunk[]>([]);
    shownSlidesCount = 0;
    private logCollector$ = timer(0).pipe(
        switchMap(() => this.installationBackendService.status({
            offset: this.offset,
            limit: LOG_CHUNK_SIZE,
        })),
        tap(res => {
            const items = res.data.items;
            const offsetDiff = items.offset - this.offset;
            this.offset = items.offset;
            const chunk = items.log;
            if (chunk) {
                this.accumulatedLog.next(this.accumulatedLog.getValue().concat([{text: chunk}]));
            }
            if (offsetDiff === 0 && this.appState.imunifyStatus.value !== AgentStatus.INSTALLING) {
                this.stopWatchingLog();
            }
            if (this.appState.imunifyStatus.value === AgentStatus.OK) {
                this.router.navigate(['/'], {
                    replaceUrl: true,
                });
            }
        }),
        catchError(() => timer(LOG_REFRESH_INTERVAL)),
        repeat({ delay: LOG_REFRESH_INTERVAL }),
    );
    private statusWatcher$ = timer(0).pipe(
        switchMap(() => this.installationBackendService.status({
            offset: this.offset,
            limit: LOG_CHUNK_SIZE,
        })),
        tap(res => {
            if (this.appState.imunifyStatus.value !== AgentStatus.INSTALLING) {
                this.stopWatchingStatus();
            }
        }),
        catchError(() => timer(STATUS_REFRESH_INTERVAL)),
        repeat({ delay: STATUS_REFRESH_INTERVAL }),
    );
    private logCollectorSubscription = Subscription.EMPTY;
    private statusCollectorSubscription = Subscription.EMPTY;
    private offset = 0;

    constructor(
        private router: Router,
        private appState: AppState,
        private installationBackendService: InstallationBackendService,
    ) {}

    start() {
        this.offset = 0;
        this.accumulatedLog.next([]);
        return this.installationBackendService.start();
    }

    startWatchingLog() {
        this.logCollectorSubscription = this.logCollector$.subscribe();
    }

    startWatchingStatus() {
        this.statusCollectorSubscription = this.statusWatcher$.subscribe();
    }

    stopWatchingLog() {
        this.logCollectorSubscription.unsubscribe();
    }

    stopWatchingStatus() {
        this.statusCollectorSubscription.unsubscribe();
    }
}
